// ============================================================
// FONTE UNICA DI VERITÀ PER TUTTE LE REGIONI ITALIANE
// Le chiavi usano il campo "name" di regionList.json
// ============================================================

import regionList from './regionList.json';

export const REGIONS = {
    'piemonte': { coords: [45.0703, 7.6869], bounds: { north: 46.5, south: 44.1, east: 9.2, west: 6.6 }, avalancheZone: 'piemonte-nord' },
    'valle_di_aosta': { coords: [45.7383, 7.3206], bounds: { north: 46.0, south: 45.5, east: 7.9, west: 6.7 }, avalancheZone: 'valle-aosta' },
    'lombardia': { coords: [45.4642, 9.1900], bounds: { north: 46.6, south: 44.6, east: 11.5, west: 8.5 }, avalancheZone: 'lombardia' },
    'trentino_alto_adige': { coords: [46.0664, 11.1257], bounds: { north: 47.1, south: 45.7, east: 12.5, west: 10.4 }, avalancheZone: 'trentino' },
    'veneto': { coords: [45.4408, 12.3155], bounds: { north: 46.7, south: 44.8, east: 13.0, west: 10.6 }, avalancheZone: 'veneto' },
    'friuli_venezia_giulia': { coords: [45.6495, 13.7768], bounds: { north: 46.7, south: 45.5, east: 13.9, west: 12.3 }, avalancheZone: null },
    'liguria': { coords: [44.4056, 8.9463], bounds: { north: 44.7, south: 43.8, east: 10.1, west: 7.5 }, avalancheZone: null },
    'emilia_romagna': { coords: [44.4949, 11.3426], bounds: { north: 45.1, south: 43.7, east: 12.8, west: 9.2 }, avalancheZone: null },
    'toscana': { coords: [43.7711, 11.2486], bounds: { north: 44.4, south: 42.2, east: 12.4, west: 9.7 }, avalancheZone: null },
    'umbria': { coords: [43.1122, 12.3888], bounds: { north: 43.6, south: 42.4, east: 13.3, west: 11.9 }, avalancheZone: null },
    'marche': { coords: [43.6158, 13.5189], bounds: { north: 44.0, south: 42.7, east: 13.9, west: 12.2 }, avalancheZone: null },
    'lazio': { coords: [41.9028, 12.4964], bounds: { north: 42.8, south: 40.8, east: 13.9, west: 11.5 }, avalancheZone: null },
    'abruzzo': { coords: [42.3498, 13.3995], bounds: { north: 42.9, south: 41.7, east: 14.8, west: 13.1 }, avalancheZone: null },
    'molise': { coords: [41.6759, 14.6099], bounds: { north: 42.0, south: 41.4, east: 15.2, west: 14.1 }, avalancheZone: null },
    'campania': { coords: [40.8518, 14.2681], bounds: { north: 41.5, south: 40.0, east: 15.8, west: 13.8 }, avalancheZone: null },
    'puglia': { coords: [41.1171, 16.8719], bounds: { north: 42.2, south: 39.8, east: 18.5, west: 14.9 }, avalancheZone: null },
    'basilicata': { coords: [40.6389, 15.8056], bounds: { north: 40.9, south: 39.9, east: 16.9, west: 15.4 }, avalancheZone: null },
    'calabria': { coords: [38.9100, 16.5877], bounds: { north: 40.2, south: 37.9, east: 17.2, west: 15.6 }, avalancheZone: null },
    'sicilia': { coords: [37.5999, 14.0153], bounds: { north: 38.8, south: 36.6, east: 15.6, west: 12.4 }, avalancheZone: null },
    'sardegna': { coords: [40.1209, 9.0129], bounds: { north: 41.3, south: 38.9, east: 9.8, west: 8.1 }, avalancheZone: null },
};

// Verifica a runtime che regionList.json e REGIONS siano sincronizzati
if (process.env.NODE_ENV === 'development') {
    regionList.regions.forEach(({ name }) => {
        if (!REGIONS[name]) console.warn(`⚠️ regionData.js: "${name}" presente in regionList.json ma mancante in REGIONS`);
    });
    Object.keys(REGIONS).forEach(name => {
        if (!regionList.regions.find(r => r.name === name)) console.warn(`⚠️ regionData.js: "${name}" presente in REGIONS ma mancante in regionList.json`);
    });
}

// ============================================================
// HELPER DERIVATI
// ============================================================

/** Per LocationButton — isInRegion(lat, lon, 'lombardia') */
export function isInRegion(lat, lon, regionName) {
    const b = REGIONS[regionName]?.bounds;
    if (!b) return false;
    return lat <= b.north && lat >= b.south && lon <= b.east && lon >= b.west;
}

/** Per WeatherAlerts — restituisce il name (es. 'lombardia') */
export function getRegionByCoords(lat, lon) {
    for (const [name, { bounds: b }] of Object.entries(REGIONS)) {
        if (lat <= b.north && lat >= b.south && lon <= b.east && lon >= b.west) {
            return name;
        }
    }
    return null;
}

/** Per WeatherAlerts — zona AINEVA con caso speciale Trentino */
export function getAvalancheZone(lat, lon) {
    const name = getRegionByCoords(lat, lon);
    if (name === 'trentino_alto_adige') {
        return lat > 46.4 ? 'alto-adige' : 'trentino';
    }
    return REGIONS[name]?.avalancheZone ?? null;
}

